import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { EventTestClockDto, UpdateEventTestModeRequestDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

interface UpdateEventTestModeParams extends UpdateEventTestModeRequestDto {
  eventId: number;
}

const updateEventTestMode = async ({
  eventId,
  isTest,
}: UpdateEventTestModeParams): Promise<EventTestClockDto> => {
  const response = await apiFetch(`api/admin/events/${eventId}/test-mode`, {
    method: "PATCH",
    body: JSON.stringify({ isTest }),
  });

  if (!response.ok) {
    throw new Error(await getApiErrorMessage(response));
  }

  return response.json();
};

export const useUpdateEventTestMode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEventTestMode,
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["events"] }),
  });
};
